import * as sysMgtDeptService from "./SysMgtDeptService";
import * as sysMgtPackageService from "./SysMgtPackageService";
import * as sysMgtMenuService from "./SysMgtMenuService";
import * as sysMgtUserService from "./SysMgtUserService";
import * as sysMgtRoleService from "./SysMgtRoleService";
import * as leaderUserService from "./leaderUserService";
import * as leaderTreeService from "./leaderTreeService";
import * as distributionTerminalService from "./distributionTerminalService";
import * as distributionMeterService from "./distributionMeterService";
import * as distributionMonitorService from "./distributionMonitorService";
import * as distributionelecAllactionService from "./distributionelecAllactionService";
import * as runMonitorWorkConditionService from "./RunMonitorWorkConditionService";
import * as runMonitorRealTimeService from "./RunMonitorRealTimeService";
import * as runMonitorCompareAnalyzeService from "./RunMonitorCompareAnalyzeService";
import * as runMonitorAlertSearchService from "./RunMonitorAlertSearchService";
import * as distributionVideoMonitorService from "./distributionVideoMonitorService";
import * as patrolWorkOrderService from "./patrolWorkoderService";
import * as elecTempService from "./elecTempService";
import * as defectiveWorkOrderService from "./DefectiveWorkOrderService";
import * as rushRepairSheetService from "./RushRepairSheetService";
import * as OpsGeneralService from "./OpsOverviewGeneralService"
import * as OpsUnitService from "./OpsOverviewUnitService"
import * as RepairStatisticService from "./RepairStatisticService"
import * as OpsUserService from "./OpsOverviewUserService"
import * as reportTemplateService from "./reportTemplateService"
import * as ReportAddService from "./reportAddService"
import * as ReportQueryService from "./reportQueryService"
import * as ReportSettlementService from "./ReportSettlementService"
import * as ElecEnterpriseService from "./elecEnterpriseService"
import * as  RunMonitorRemoteControl from "./RunMonitorRemoteControl"
import * as  ElecDeviceReportService from "./elecDeviceReportService"
import * as  houseSettingService from "./houseSettingService"
import * as JinhuaIndex from "./jinhuaindex"
import * as terminalCheckTimeService from './terminalCheckTimeService'
import * as checkReportService from "./checkReportService"
import * as LossModelService from "./LossModelService"
import * as EneryReportService from "./EneryReportService"
import * as MeterModelItemService from "./meterModelItemService"

/**
 * 全局http服务请求入口
 */
const AgencyMaintainService = {
    sysMgtDeptService,    // 组织管理请求服务
    sysMgtPackageService, // 业务包管理请求服务
    sysMgtMenuService,   // 菜单管理请求服务
    sysMgtUserService, // 用户管理请求服务
    sysMgtRoleService, // 角色管理请求服务
    leaderUserService, // 台账请求服务
    leaderTreeService, // 台账树请求服务
    distributionTerminalService, // 终端管理请求服务
    distributionMeterService, // 表计管理请求服务
    distributionMonitorService, // 监控设备请求服务
    distributionVideoMonitorService,//视频监控请求服务
    distributionelecAllactionService,//电费配置请求服务
    runMonitorWorkConditionService, // 运行监控工况查询服务
    runMonitorRealTimeService, // 运行监控 实时信息服务
    runMonitorCompareAnalyzeService, // 运行监控 对比信息服务
    runMonitorAlertSearchService, // 运行监控 告警查询服务
    patrolWorkOrderService,//巡视管理
    elecTempService,  //系统模板--电费模板
    defectiveWorkOrderService, //缺陷管理请求服务
    rushRepairSheetService,//抢修管理请求服务
    RepairStatisticService,//抢修统计请求服务
    OpsGeneralService, // 运维概览服务
    OpsUnitService, // 用电单位概览服务
    OpsUserService, // 中粮首页服务
    reportTemplateService, // 报表模板服务
    ReportAddService, // 生成报表概览服务
    ReportQueryService, // 查询报表概览服务
    ReportSettlementService, // 月结电量报表概览服务
    RunMonitorRemoteControl,//远程控制概览服务
    ElecEnterpriseService,//企业综合电费
    ElecDeviceReportService,//设备综合电费
    houseSettingService,
    JinhuaIndex,// 金华综合用能管理首页（运营商）
    terminalCheckTimeService,//终端对时服务
    checkReportService,
    LossModelService,
    EneryReportService,//用能报表
    MeterModelItemService, //表计配置
};

export default AgencyMaintainService;

